"use client";

import { useEffect, useRef } from "react";

import { event as gaEvent } from "@/lib/gtag";
import type { BlogEntryMode } from "@/lib/blog/measurement";

export function BlogMeasurementView({
  category,
  entryMode,
  queryLength,
  resultCount,
}: {
  category?: string;
  entryMode: BlogEntryMode;
  queryLength: number;
  resultCount: number;
}) {
  const trackedSignatureRef = useRef<string | null>(null);

  useEffect(() => {
    const signature = [entryMode, category ?? "all", queryLength, resultCount].join(
      "|"
    );
    if (trackedSignatureRef.current === signature) return;
    trackedSignatureRef.current = signature;

    gaEvent("blog_directory_view", {
      blog_entry_mode: entryMode,
      category: category ?? "all",
      query_length: queryLength,
      result_count: resultCount,
    });
  }, [category, entryMode, queryLength, resultCount]);

  return null;
}
